<template>
  <div class="bottom-wrap w-full flex flex-row items-center gap-3 bg-white">

    <div  v-if="showEdit" class="relative flex flex-col items-center " :class="disabled ? 'disable-click':''">
      <van-image @click="onBrandEditClick" :src="require('@/assets/icons/v2/icon_brand_edit.png')"
          fit="contain" class="bt-nfc-icon-size"/>
      <div v-if="showTriangle" class="rb-triangle absolute right-1.5 bottom-1.5"></div>
    </div>

    <div class="flex flex-row items-center w-full">
      <div v-if="showDelete" :class="disabled ? 'disable-click':''" @click="onDeleteClick"
          class="flex-1  mr-3  delete-back-btn radius-border text-center">{{ deleteText }}
      </div>
      <div :class="disabled ? 'disable-click':''" @click="onNextClick"
          class="flex-1 bottom-back-btn text-center">{{ text }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "CustomizationBottomOperate",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Enter"
    },
    showTriangle: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    deleteText: {
      type: String,
      default: "Delete"
    }
  },
  methods: {
    onBrandEditClick() {
      this.$emit("onBrandEdit");
    },
    onNextClick() {
      this.$emit("onNext");
    },
    onDeleteClick() {
      this.$emit("onDelete");
    }
  }
};
</script>

<style scoped lang="less">
.bt-nfc-icon-size {
  padding: 12px;
  border-radius: 12px;
  border: 1px #BEBEBE solid;
  width: 48px;
  height: 48px;
}


.rb-triangle {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 6px solid black;
  border-bottom: 0px solid transparent;
  border-left: 0px solid transparent;
  z-index: 2;
}


</style>